document.addEventListener("DOMContentLoaded", function() {
  let filterNewsButton = document.querySelector(
      ".hoverdoor__wrap .category-search__pastcurrent__button"
    ),
    layer = document.querySelector(".category-search__pastcurrent__layer");

  if (filterNewsButton) {
    function fliterToggleMenu() {
      let menu = document.querySelector(".category-search__pastcurrent__menu");
      menu.classList.toggle("show");
      layer.classList.toggle("active");
    }

    filterNewsButton.addEventListener("click", function() {
      fliterToggleMenu();
    });

    layer.addEventListener("click", function() {
      fliterToggleMenu();
    });

    for (let i = 0; i <= 900; i++) {
      let filterMenuList = document.querySelector(
          ".category-search__pastcurrent__list"
        ),
        countYearArticle = "",
        showYear = "",
        countYearArticleElAll = "";

      if (i < 10) {
        countYearArticle = ".hoverdoor__article__200" + [i];
        showYear = "200";
        countYearArticleElAll = document.querySelectorAll(countYearArticle);
        chooseYearClass = ".category-search__pastcurrent__listitem__200" + [i];
        chooseYear = document.querySelector(chooseYearClass);
      } else {
        countYearArticle = ".hoverdoor__article__20" + [i];
        showYear = "20";
        countYearArticleElAll = document.querySelectorAll(countYearArticle);
        chooseYearClass = ".category-search__pastcurrent__listitem__20" + [i];
        chooseYear = document.querySelector(chooseYearClass);
      }

      if (countYearArticleElAll.length >= 1) {
        filterMenuList.innerHTML +=
          "<li class='category-search__pastcurrent__listitem title category-search__pastcurrent__listitem__" +
          showYear +
          [i] +
          "'><a href='#" +
          showYear +
          [i] +
          " '><span>" +
          showYear +
          [i] +
          "</span><span>(" +
          countYearArticleElAll.length +
          ")</span></a></li>";
      }
    }

    for (let i = 0; i <= 900; i++) {
      let chooseYear = "",
        chooseYearClass = "",
        theYear = "";

      if (i < 10) {
        chooseYearClass = ".category-search__pastcurrent__listitem__200" + [i];
        chooseYear = document.querySelector(chooseYearClass);
        theYear = "200" + [i];
      } else {
        chooseYearClass = ".category-search__pastcurrent__listitem__20" + [i];
        chooseYear = document.querySelector(chooseYearClass);
        theYear = "20" + [i];
      }

      if (chooseYear) {
        chooseYear.addEventListener("click", function() {
          let hoverDoorAll = document.querySelectorAll(".hoverdoor__article"),
            hoverDoorClass = ".hoverdoor__article__" + theYear,
            buttonYear = document.querySelector(
              ".category-search__pastcurrent__button"
            ),
            hoverDoor = document.querySelectorAll(hoverDoorClass);

          buttonYearText = buttonYear.textContent;
          let res = buttonYearText.replace(buttonYearText, theYear);
          document.querySelector(
            ".category-search__pastcurrent__button_year"
          ).innerHTML = res;

          for (let i = 0; i < hoverDoorAll.length; i++) {
            hoverDoorAll[i].style.display = "none";
          }

          for (let i = 0; i < hoverDoor.length; i++) {
            hoverDoor[i].style.display = "flex";
          }
          fliterToggleMenu();
        });
      }

      if (window.location.href.indexOf("#" + theYear) != -1) {
        let hoverDoorAll = document.querySelectorAll(".hoverdoor__article"),
          hoverDoorClass = ".hoverdoor__article__" + theYear,
          buttonYear = document.querySelector(
            ".category-search__pastcurrent__button"
          ),
          hoverDoor = document.querySelectorAll(hoverDoorClass);

        buttonYearText = buttonYear.textContent;
        let res = buttonYearText.replace(buttonYearText, theYear);
        document.querySelector(
          ".category-search__pastcurrent__button_year"
        ).innerHTML = res;

        for (let i = 0; i < hoverDoorAll.length; i++) {
          hoverDoorAll[i].style.display = "none";
        }

        for (let i = 0; i < hoverDoor.length; i++) {
          hoverDoor[i].style.display = "flex";
        }
      }
    }
    let showAllHoverDoor = document.querySelector(
      ".category-search__pastcurrent__listitem__all"
    );
    let allHoverDoors = document.querySelectorAll(".hoverdoor__article");
    showAllHoverDoor.addEventListener("click", function() {
      for (let i = 0; i < allHoverDoors.length; i++) {
        allHoverDoors[i].style.display = "flex";
      }
      buttonYear = document.querySelector(
        ".category-search__pastcurrent__button"
      );
      document.querySelector(
        ".category-search__pastcurrent__button_year"
      ).innerHTML = " ";
      fliterToggleMenu();
    });
  }
});
